import request from '@/utils/request'
import qs from 'qs'

let formHeader = {'Content-Type': 'application/x-www-form-urlencoded',}

export function queryWebsite(data) {
    return request({
        url: '/api-admin/website/queryWebsite',
        method: 'get',
        headers: formHeader,
        params: data
    })
}

export function updateWebsite(data) {
    return request({
        url: '/api-admin/website/updateWebsite',
        method: 'post',
        data: data
    })
}

export function createHtml() {
    return request({
        url: '/api-admin/website/createHtml',
        method: 'get'
    })
}

export function deleteWebsite(id) {
    return request({
        url: '/api-admin/website/delete',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: { id }
    })
}

export function queryWebsiteType(data) {
    return request({
        url: '/api-admin/websiteType/queryWebsiteType',
        method: 'get',
        headers: formHeader,
        params: data
    })
}

export function updateWebsiteType(data) {
    return request({
        url: '/api-admin/websiteType/updateWebsiteType',
        method: 'post',
        headers: formHeader,
        data: qs.stringify(data)
    })
}